import colors from '../primitives/colors'

export const text = {
    button: {
        primary: {
            default: colors.white,
            hover: colors.black,
            pressed: colors.white,
            disabled: colors.grey[400],
        },
        secondary: {
            default: colors.black,
            hover: colors.black,
            pressed: colors.black,
            disabled: colors.grey[400],
        },
        newsletter: {
            default: colors.white,
            hover: colors.black,
            pressed: colors.white,
        },
        filter: {
            default: colors.black,
            hover: colors.black,
            pressed: colors.black,
        },
        textLink: {
            default: colors.black,
            hover: colors.black,
            pressed: colors.black,
            disabled: colors.grey[400],
        },
        iconButton: {
            default: colors.black,
            hover: colors.black,
            disabled: colors.grey[400],
        },
        outline: {
            default: colors.black,
            hover: colors.black,
            pressed: colors.black,
            disabled: colors.grey[400],
        },
        menu: {
            default: colors.black,
            negative: colors.white,
            hover: colors.black,
        },
    },
    breadcrumb: {
        inactive: colors.grey[600],
        active: colors.black,
    },
    input: {
        base: colors.black,
        disabled: colors.grey[600],
        placeholder: colors.grey[600],
    },
    accordion: {
        default: colors.black,
        hover: colors.black,
    },
    option: {
        base: colors.black,
        negative: colors.white,
    },
    drawer: {
        default: colors.black,
    },
    tab: {
        default: colors.grey[600],
        active: colors.black,
    },
    alertText: {
        default: colors.alertMessage.text,
    },
    ...colors,
}
export const border = {
    button: {
        secondary: colors.black,
        outline: {
            default: colors.black,
            hover: colors.grey[300],
        },
        textLink: colors.black,
        none: colors.transparent,
    },
    input: {
        primary: colors.black,
        search: colors.grey[300],
        error: colors.error,
        disabled: colors.grey[400],
        warning: colors.alert,
        none: colors.transparent,
    },
    accordion: {
        default: colors.grey[300],
    },
    drawer: {
        default: colors.grey[300],
    },
    tab: {
        default: colors.transparent,
        active: colors.black,
    },
    footer: {
        default: colors.grey[300],
    },
    header: {
        default: colors.grey[300],
    },
    alertBorder: {
        default: colors.alertMessage.border,
    },
    ...colors,
}
export const background = {
    button: {
        primary: {
            default: colors.black,
            hover: colors.grey[300],
            pressed: colors.black,
            disabled: colors.grey[400],
        },
        secondary: {
            default: colors.white,
            hover: colors.grey[300],
            pressed: colors.white,
            disabled: colors.grey[400],
        },
        newsletter: {
            default: colors.black,
            hover: colors.grey[300],
            pressed: colors.black,
        },
        filter: {
            default: colors.grey[200],
            hover: colors.grey[200],
            pressed: colors.grey[200],
        },
        iconButton: {
            default: colors.alpha.light[70],
            hover: colors.white,
        },
        outline: {
            default: colors.transparent,
            hover: colors.grey[300],
            pressed: colors.transparent,
            disabled: colors.grey[400],
        },
        none: colors.transparent,
    },
    accordion: {
        default: colors.white,
        hover: colors.white,
    },
    option: {
        base: colors.white,
        active: colors.black,
        hover: colors.grey[200],
    },
    loader: {
        default: colors.alpha.dark[40],
    },
    header: {
        default: colors.white,
        gradient: `linear-gradient(to bottom, rgba(0, 0, 0, .6) 0, rgba(38, 38, 38, .1) 100%)`,
    },
    sizeSelector: {
        default: colors.white,
        desktop: colors.alpha.light[90],
    },
    darkOverlay: {
        default: colors.alpha.dark[50],
    },
    alertBackground: {
        default: colors.alertMessage.background,
    },
    accessibility: {
        default: colors.grey[200],
    },
    ...colors,
}
export const icon = {
    disabled: colors.grey[200],
    ...colors,
}
